import { Button } from "@/components/ui/button";
import { useCurrency } from "@/hooks/use-currency";
import { DollarSign } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const CurrencySwitcher = () => {
  const { currency, setCurrency } = useCurrency();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <DollarSign className="h-4 w-4" />
          <span>{currency}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setCurrency("MAD")}>
          MAD - Moroccan Dirham
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setCurrency("USD")}>
          USD - US Dollar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setCurrency("EUR")}>
          EUR - Euro
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setCurrency("GBP")}>
          GBP - British Pound
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};